"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INPUT_PADDING_WITH_ICON = exports.INPUT_PADDING_DEFAULT = exports.INDETERMINATE_BAR_WIDTH = exports.INDETERMINATE_BAR_HEIGHT = exports.HOVER_INVERTED_COLOR = exports.HOVER_DETAILED_BACKGROUND_COLOR = exports.HOVER_COLOR = exports.HOVER_BACKGROUND_COLOR = exports.HOVERED_RING_SIZE = exports.FOCUS_INVERTED_COLOR = exports.FOCUS_COLOR = exports.ERROR_INVERTED_HOVER_COLOR = exports.ERROR_INVERTED_FOCUS_COLOR = exports.ERROR_INVERTED_DEFAULT_COLOR = exports.ERROR_HOVER_DETAILED_BACKGROUND_COLOR = exports.ERROR_HOVER_COLOR = exports.ERROR_HOVER_BACKGROUND_COLOR = exports.ERROR_FOCUS_COLOR = exports.ERROR_DEFAULT_COLOR = exports.DISABLED_COLOR = exports.DISABLED_BACKGROUND_COLOR = exports.DEFAULT_TEXT_COLOR = exports.DEFAULT_RING_SIZE = exports.DEFAULT_INVERTED_TEXT_COLOR = exports.DEFAULT_INVERTED_COLOR = exports.DEFAULT_COLOR = exports.DEFAULT_BACKGROUND_COLOR = exports.CHECKED_RING_SIZE = exports.CHECKBOX_BORDER_WIDTH = exports.BORDER_INVERTED_COLOR = exports.BORDER_COLOR = void 0;
var CHECKBOX_BORDER_WIDTH = 2;
exports.CHECKBOX_BORDER_WIDTH = CHECKBOX_BORDER_WIDTH;
var INDETERMINATE_BAR_HEIGHT = 2;
exports.INDETERMINATE_BAR_HEIGHT = INDETERMINATE_BAR_HEIGHT;
var INDETERMINATE_BAR_WIDTH = 14;
exports.INDETERMINATE_BAR_WIDTH = INDETERMINATE_BAR_WIDTH;
var DEFAULT_RING_SIZE = 2;
exports.DEFAULT_RING_SIZE = DEFAULT_RING_SIZE;
var HOVERED_RING_SIZE = 4;
exports.HOVERED_RING_SIZE = HOVERED_RING_SIZE;
var CHECKED_RING_SIZE = 8;
exports.CHECKED_RING_SIZE = CHECKED_RING_SIZE;
var INPUT_PADDING_DEFAULT = 8;
exports.INPUT_PADDING_DEFAULT = INPUT_PADDING_DEFAULT;
var INPUT_PADDING_WITH_ICON = 36;
exports.INPUT_PADDING_WITH_ICON = INPUT_PADDING_WITH_ICON;
var DEFAULT_BACKGROUND_COLOR = 'neutral0';
exports.DEFAULT_BACKGROUND_COLOR = DEFAULT_BACKGROUND_COLOR;
var DEFAULT_COLOR = 'primary70';
exports.DEFAULT_COLOR = DEFAULT_COLOR;
var DEFAULT_INVERTED_COLOR = 'primary40';
exports.DEFAULT_INVERTED_COLOR = DEFAULT_INVERTED_COLOR;
var DEFAULT_TEXT_COLOR = 'neutral90';
exports.DEFAULT_TEXT_COLOR = DEFAULT_TEXT_COLOR;
var DEFAULT_INVERTED_TEXT_COLOR = 'neutral0';
exports.DEFAULT_INVERTED_TEXT_COLOR = DEFAULT_INVERTED_TEXT_COLOR;
var BORDER_COLOR = 'neutral50';
exports.BORDER_COLOR = BORDER_COLOR;
var BORDER_INVERTED_COLOR = 'neutral20';
exports.BORDER_INVERTED_COLOR = BORDER_INVERTED_COLOR;
var HOVER_COLOR = 'primary60';
exports.HOVER_COLOR = HOVER_COLOR;
var HOVER_INVERTED_COLOR = 'primary30';
exports.HOVER_INVERTED_COLOR = HOVER_INVERTED_COLOR;
var HOVER_BACKGROUND_COLOR = 'primary05';
exports.HOVER_BACKGROUND_COLOR = HOVER_BACKGROUND_COLOR;
var HOVER_DETAILED_BACKGROUND_COLOR = 'primary90';
exports.HOVER_DETAILED_BACKGROUND_COLOR = HOVER_DETAILED_BACKGROUND_COLOR;
var FOCUS_COLOR = 'primary80';
exports.FOCUS_COLOR = FOCUS_COLOR;
var FOCUS_INVERTED_COLOR = 'primary50';
exports.FOCUS_INVERTED_COLOR = FOCUS_INVERTED_COLOR;
var ERROR_DEFAULT_COLOR = 'red70';
exports.ERROR_DEFAULT_COLOR = ERROR_DEFAULT_COLOR;
var ERROR_INVERTED_DEFAULT_COLOR = 'red40';
exports.ERROR_INVERTED_DEFAULT_COLOR = ERROR_INVERTED_DEFAULT_COLOR;
var ERROR_HOVER_COLOR = 'red60';
exports.ERROR_HOVER_COLOR = ERROR_HOVER_COLOR;
var ERROR_INVERTED_HOVER_COLOR = 'red30';
exports.ERROR_INVERTED_HOVER_COLOR = ERROR_INVERTED_HOVER_COLOR;
var ERROR_FOCUS_COLOR = 'red80';
exports.ERROR_FOCUS_COLOR = ERROR_FOCUS_COLOR;
var ERROR_INVERTED_FOCUS_COLOR = 'red50';
exports.ERROR_INVERTED_FOCUS_COLOR = ERROR_INVERTED_FOCUS_COLOR;
var ERROR_HOVER_BACKGROUND_COLOR = 'red05';
exports.ERROR_HOVER_BACKGROUND_COLOR = ERROR_HOVER_BACKGROUND_COLOR;
var ERROR_HOVER_DETAILED_BACKGROUND_COLOR = 'red90';
exports.ERROR_HOVER_DETAILED_BACKGROUND_COLOR = ERROR_HOVER_DETAILED_BACKGROUND_COLOR;
var DISABLED_COLOR = 'neutral70';
exports.DISABLED_COLOR = DISABLED_COLOR;
var DISABLED_BACKGROUND_COLOR = 'neutral20';
exports.DISABLED_BACKGROUND_COLOR = DISABLED_BACKGROUND_COLOR;